<template>
  <statements-reports />
</template>

<script>
import StatementsReports from "@/containers/Reports/StatementsReports";
export default {
  components: {
    StatementsReports
  }
};
</script>
